import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { PdfFormInboxItem } from "@/Patient/Models/ShareItems/PdfFormInboxItem";

import styles from "./RadPdfFormSettingPopup.module.scss";

interface IRadpdfFormSettingPopupProps {
    form: PdfFormInboxItem;
    encounterId: string;
    onDeleteClick: () => void;
}

function RadPdfFormSettingPopup(props: IRadpdfFormSettingPopupProps): JSX.Element {
    const { getText } = useTranslation();

    const hideContextMenu = (form: PdfFormInboxItem): void => {
        const operation = new LocalEvent(LocalPatientOperations.MedicalNote.CloseContextMenuPdf);
        operation.AddItem("form", form);
        LocalEventDispatcher.dispatch(operation);
    };

    const toggleFormPersistance = (form: PdfFormInboxItem, e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();
        const operation = new LocalEvent(LocalPatientOperations.MedicalNote.toggleFormPersistance);
        operation.AddItem("form", form);
        LocalEventDispatcher.dispatch(operation);
    };

    return (
        <div className={styles.radPdfsettignsContainer} onMouseLeave={() => hideContextMenu(props.form)} onClick={() => hideContextMenu(props.form)}>
            <div className={styles.formContextMenu}>
                <div className={styles.contextItem}>
                    <span className="glyphicon glyphicon-trash red-text" />
                    <a onClick={() => props.onDeleteClick()}>
                        {getText("DeleteLabel")}
                    </a>
                </div>
                <div className={styles.contextItem}>
                    {props.form.IsPersistant
                        ? (
                            <div>
                                <span className={`${styles.star} glyphicon glyphicon-star`} />
                                <a onClick={e => toggleFormPersistance(props.form, e)}>
                                    {getText("HideFromFutureNotesLabel")}
                                </a>
                            </div>
                        )
                        : (
                            <div>
                                <span className={`${styles.star} glyphicon glyphicon-star-empty`} />
                                <a onClick={e => toggleFormPersistance(props.form, e)}>
                                    {getText("FormShare")}
                                </a>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
}

export { RadPdfFormSettingPopup };
